export interface HierarchyHistoryDto extends Record<string, string | number> {
  id: number;
  date: string;
  action: string;
  comment: string;
  userId: number;
  userName: string;
}

/**
 * Type guard that asserts whether a value conforms to the HierarchyHistoryDto shape.
 *
 * @param obj - The object to check
 * @returns - boolean
 */
export const isHierarchyHistoryDto = (obj: unknown): obj is HierarchyHistoryDto => {
  // Check object
  if (typeof obj !== "object" || obj === null) return false;
  // Check properties exist and types
  const chkObj = obj as HierarchyHistoryDto;
  if (typeof chkObj.id !== "number") return false;
  if (typeof chkObj.date !== "string") return false;
  if (typeof chkObj.action !== "string") return false;
  if (typeof chkObj.comment !== "string") return false;
  if (typeof chkObj.userId !== "number") return false;
  if (typeof chkObj.userName !== "string") return false;
  // Everything is good
  return true;
};
